module.exports = __webpack_public_path__ + "static/media/fingerprint-banner.f7c56423.jpg";